import { render, staticRenderFns } from "./OrganisationListFilter.vue?vue&type=template&id=5dc910e6&"
import script from "./OrganisationListFilter.vue?vue&type=script&lang=js&"
export * from "./OrganisationListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports